module.exports = __webpack_public_path__ + "static/media/vlajka_sk_gray.f615b8c8.svg";